import * as cx from 'classnames';
import * as React from 'react';
import { ChangeEvent, FocusEvent } from 'react';
import { FieldMessage } from '..';
import * as Styles from './InputBox.scss';

/* const withContex = (WrappedComponent: React.ComponentType<InjectedProps>) => (remainingProps: IOwnProps) => (
  <CheckoutContextConfig.Consumer>
    {checkoutContextConfig => <WrappedComponent {...remainingProps} guiType={checkoutContextConfig.ui.inputBox.guiType} />}
  </CheckoutContextConfig.Consumer>
); */

interface IOwnProps {
  id: string;
  name: string;
  type: string;
  variant?: 'tick' | 'toggle';
  displayRadioDirection?: 'row' | 'column';
  sizeVariant?: 'big';
  reverse?: boolean;
  label: string | JSX.Element;
  value: any;
  note?: string;
  errors?: {};
  touched?: any;
  onClick?: (event: React.SyntheticEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  checked?: boolean;
  required?: boolean;
  klarnaTermsElementId?: string;
}

const InputBox: React.SFC<IOwnProps> = (props) => {
  const {
    type,
    value,
    variant,
    sizeVariant,
    checked,
    label,
    errors,
    touched,
    note,
    reverse,
    klarnaTermsElementId,
    displayRadioDirection = 'row',
    ...restProps
  } = props;

  const inputBoxClassNames = cx({
    [Styles.inputBox]: true,
    [value]: type === 'radio',
    [Styles.radio]: type === 'radio',
    [Styles.checkbox]: type === 'checkbox',
    [Styles.toggle]: variant === 'toggle',
    [Styles.big]: sizeVariant === 'big',
    [Styles.reverse]: reverse,
    [Styles.column]: displayRadioDirection === 'column',
  });

  const inputClassNames = cx({
    [Styles.input]: true,
    [Styles.inputToggle]: variant === 'toggle',
    [Styles.checked]: checked,
    [Styles.error]: errors && touched,
  });

  const labelClassNames = cx({
    [Styles.label]: true,
    [Styles.selected]: displayRadioDirection === 'column' && checked,
  });

  const errorWrapperClassNames = cx({
    [Styles.errorWrapper]: true,
    [Styles.noPaddingLeft]: reverse,
  });

  return (
    <div className={inputBoxClassNames} data-block-for={value}>
      <label className={labelClassNames}>
        <input
          {...restProps}
          type={type}
          checked={checked}
          value={value}
          // title={label}
          className={inputClassNames}
        />
        <span className={Styles.labelInner}>
          <span className={Styles.labelElements}>
            <span className={Styles.labelText}>{label}</span>
            {klarnaTermsElementId && <span id={klarnaTermsElementId} className={Styles.klarnaTerms} />}
          </span>
          {note && <span className={Styles.note}>{note}</span>}
        </span>
      </label>
      {errors && touched && <div className={errorWrapperClassNames}>
        <FieldMessage error={true} message={errors} />
      </div>}
    </div>
  );
};

export default InputBox;
